import { IdObject } from '@campaign-portal/namespace/common/idObject';
import { exist, Id } from '@campaign-portal/namespace/common/id';

export function prepareToSave<T extends IdObject<exist>>(
	selectedEntity: Id<exist>[] | null,
	allEntity: T[]
): Id<exist>[] {
	return selectedEntity === null ? allEntity.map((item: T) => item.id) : selectedEntity;
}
